<template>
  <v-dialog
    :value="value"
    :persistent="loading"
    width="350"
    class="UnlinkSchoolDialog"
    @input="$emit('input', $event)"
  >
    <v-card :loading="loading">
      <v-card-title>Unlink school</v-card-title>
      <v-card-text>
        <p>
          To confirm that you want to unlink school from your account write linked or requested
          school id <b>{{ requestedSchoolId }}</b> in the confirmation field below
        </p>
        <v-text-field
          v-model="confirmationSchoolId"
          :disabled="loading"
          label="School id"
          outlined
          hide-details
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          :disabled="loading"
          text
          @click="close"
        >
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          :disabled="confirmationSchoolId !== requestedSchoolId"
          :loading="loading"
          color="red"
          class="white--text"
          @click="unlinkSchool"
        >
          Unlink
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { handleReqErrorWithToast } from '@/helpers/error-handlers';

export default {
  name: 'UnlinkSchoolDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmationSchoolId: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters('children', [
      'activeChildProfile',
    ]),
    requestedSchoolId() {
      return this.activeChildProfile.school_id || this.activeChildProfile.requested_school_id;
    },
  },
  methods: {
    ...mapActions('children', [
      'cancelSchoolLinking',
    ]),
    unlinkSchool() {
      if (this.loading) return;

      this.loading = true;

      this.cancelSchoolLinking({ confirmationSchoolId: this.confirmationSchoolId })
        .then(() => {
          this.$toast.success('School unlinked successfully');
          this.confirmationSchoolId = '';
          this.close();
        })
        .catch(err => handleReqErrorWithToast(err, 'Failed to unlink school'))
        .finally(() => (this.loading = false));
    },
    close() {
      this.$emit('input', false);
    },
  },
};
</script>
